import { useTranslation } from 'libs/i18n';
// eslint-disable-next-line no-restricted-imports
import { useRouteError as useRouteErrorBase } from 'react-router-dom';
import { RouteError, NotFount } from 'types/error';

export const useRouteError = () => {
  const error = useRouteErrorBase();
  const { t } = useTranslation();

  if (error instanceof RouteError) {
    return { error, message: error.message };
  }
  if (error instanceof NotFount) {
    return { error, message: t('notFound.subtitle') };
  }

  return { error };
};
